const generatedStrings = new Set();

export function Serial_number(length, last_number) {
  if (!last_number) {
    return String(1).padStart(length, "0");
  }

  // Ensure last_number is a string
  last_number = String(last_number);

  // Convert to number and increment
  const next = parseInt(last_number, 10) + 1;

  // Pad with leading zeros
  return String(next).padStart(length, "0");
}